if (!customElements.get("custom-slider")) {
  class Slider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.scrollBar = this.querySelector(".swiper-scrollbar");
      this.navigationNext = this.querySelector(".swiper-button-next");
      this.navigationPrev = this.querySelector(".swiper-button-prev");
      this.pagination = this.querySelector(".swiper-pagination");
      this.dots = this.querySelector(".swiper-pagination-bullet");
      this.dotsActive = this.querySelector(".swiper-pagination-bullet-active");

      const swiper = new Swiper(this, {
        slidesPerView: this.dataset.visibleSlidesMobile,
        spaceBetween: this.dataset.spaceBetween,
        breakpoints: {
          750: {
            slidesPerView: this.dataset.visibleSlides ? this.dataset.visibleSlides : this.dataset.visibleSlidesMobile,
          },
        },
        scrollbar: {
          el: this.scrollBar,
          draggable: true,
        },
        navigation: {
          nextEl: this.navigationNext,
          prevEl: this.navigationPrev,
        },
      });
    }
  }

  customElements.define("custom-slider", Slider);
}
